export default __webpack_public_path__ + "static/media/Nithing Beheader.4cbbcfd4.jpg";